export default function labelForm (initialLabelsEl, allLabelsEl) {
    const initialLabels = utils.getJsonScript(initialLabelsEl)
    const allLabels = utils.getJsonScript(allLabelsEl)
    return {
        modalOpen: false,
        labels: allLabels.map(label => ({
            name: label,
            selected: initialLabels.includes(label),
            hasBeenSelected: initialLabels.includes(label)
        })),
        newLabelText: '',
        findLabel(name) {
            return this.labels.find(label => label.name === name)
        },
        findOrCreateLabel(name, selected=true) {
            let label = this.findLabel(name)
            if (!label) {
                label = { name, selected, hasBeenSelected: selected }
                this.labels.push(label)
            }
            return label
        },
        createLabel(event) {
            event.preventDefault()
            if (this.newLabelText === '') {
                return
            }
            const labelName = this.newLabelText.toLowerCase()
            const label = this.findOrCreateLabel(labelName)
            this.turnOnLabel(label)
            this.newLabelText = ''
        },
        turnOnLabel(label) {
            label.selected = true
            label.hasBeenSelected = true
        },
        toggleLabel(label) {
            label.selected = !label.selected
            label.hasBeenSelected = label.hasBeenSelected || label.selected
        },
    }
}
